import { MosError } from 'src/utils/errors/MosError';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import type {
  SessionListResponse,
  GetMySessionsParams,
} from 'src/types/session';

const getMySessions = async (
  params?: GetMySessionsParams,
): Promise<SessionListResponse> => {
  const authTokenHttp = await getCompatibleAuthTokenHttp();

  const queryParams = new URLSearchParams();
  if (params?.tenantId) {
    queryParams.append('tenantId', params.tenantId);
  }
  if (params?.includeInactive !== undefined) {
    queryParams.append('includeInactive', String(params.includeInactive));
  }
  if (params?.limit) {
    queryParams.append('limit', String(params.limit));
  }
  if (params?.cursor) {
    queryParams.append('cursor', params.cursor);
  }

  const queryString = queryParams.toString();
  let url: string = '/shared/users/me/sessions';
  if (queryString) {
    url += `?${queryString}`;
  }

  const response = await authTokenHttp<SessionListResponse>(url, {
    method: 'GET',
  });

  if (response.data) {
    return response.data;
  }

  throw new MosError({
    error: 'Failed to fetch sessions',
    statusCode: response.status,
  });
};

export default getMySessions;
